import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./search-results-page.${locale}.json`));
